import { forwardRef } from "react";
import Button from "./Button";

/**
 * Button that only has an icon and no content.
 * @param {object} props
 * @param {"xs" | "sm" | "md" | "lg" | "xl" | "2xl" | { iconSize: string; paddingX: string; paddingY: string; }} props.size The size of the button.
 * @param {"primary" | "secondary" | "danger" | { buttonBackgroundColor: string; buttonTextColor: string; }} props.colorTheme The color theme for the button. Defaults to `primary`.
 * @param {{ text: string; show?: boolean; } | undefined} props.tooltipProps Props for the tooltip. To show the tooltip on mouseover, leave the `show` property undefined.
 * @param {React.MouseEventHandler<HTMLButtonElement> | undefined} props.handleOnClick Handler for the button click event.
 * @param {React.ReactNode} props.iconComponent The icon for the button.
 */
function IconOnlyButton({ size, colorTheme = "primary", handleOnClick, tooltipProps, iconComponent, ...props }, ref) {
    return (
        <Button
            {...props}
            ref={ref}
            size={size}
            colorTheme={colorTheme}
            handleOnClick={(event) => {
                if (handleOnClick) {
                    handleOnClick(event);
                }
            }}
            tooltipProps={tooltipProps}
            iconComponent={iconComponent}
        />
    );
}

export default forwardRef(IconOnlyButton);
